import React from 'react';
import PropTypes from 'prop-types';
import { CenteredContainer, Title, Text } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import HomePageReg from '../../home-page-reg/home-page-reg';

const RegistrationModule = ({ title, subtitle, backgroundImage }) => {
  const imageProps = {
    src: backgroundImage,
    alt: `${title} background image`,
    backgroundColor: 'transparent',
    role: 'presentation',
    lazy: true,
  };

  return (
    <BedrockImpression entityName="hp_reg_successful_display">
      <div className="registration-wrapper">
        <CenteredContainer
          paddingLeft={0}
          paddingRight={0}
          className="registration-module-cont"
        >
          <div className="registration-module">
            <div className="registration-module__text">
              <Title size="small" component="h2">
                {title}
              </Title>
              <div className="registration-module__subtitle">
                <Text>{subtitle}</Text>
              </div>
              <div className="registration-module__subtitle-mobile">
                <Text>{subtitle}</Text>
              </div>
              <div className="auth-container">
                <HomePageReg />
              </div>
              <Image
                {...imageProps}
                className="registration-module-image__mobile"
              />
            </div>
          </div>
          <Image {...imageProps} className="registration-module-image" />
        </CenteredContainer>
      </div>
    </BedrockImpression>
  );
};

RegistrationModule.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  backgroundImage: PropTypes.string,
};

RegistrationModule.displayName = 'RegistrationModule';

export default RegistrationModule;
